import { render, staticRenderFns } from "./ParallelConversation.vue?vue&type=template&id=a1cb6a12"
import script from "./ParallelConversation.vue?vue&type=script&lang=js"
export * from "./ParallelConversation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports